import * as React from 'react'
import { Grid } from '@mds/mds-reactjs-library'
import Error from '../components/Error'
import ViewLayout, { classes } from '../components/ViewLayout'
import { ForbiddenAccessIcon } from '../icons'
import type { Customization } from '../types/Customization'

const title = 'Access Denied'
const defaultSolutionName = 'the solution owner'

type AccessDeniedProps = {
  customization?: Customization
}

const getText = ({ customization }: AccessDeniedProps) => (
  <p>
    Your access has been denied.
    <br />
    Please contact{' '}
    {!!customization?.enrollmentHomeUrl && !!customization?.enrollmentTeamName ? (
      <a href={customization.enrollmentHomeUrl}>{customization.enrollmentTeamName}</a>
    ) : (
      defaultSolutionName
    )}{' '}
    for further information.
  </p>
)

const AccessDenied = ({ customization }: AccessDeniedProps): JSX.Element => (
  <ViewLayout>
    <section className={classes.wrappingBox}>
      <Grid item span={12}>
        <Error icon={<ForbiddenAccessIcon />} title={title} text={getText({ customization })} />
      </Grid>
    </section>
  </ViewLayout>
)

export default AccessDenied
